<router-outlet />
<app-version-update-banner />
